import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import { UserProvider } from './context/UserContext';
import './styles/index.css';

/**
 * App Component
 * Главный компонент приложения Proton-X Mail
 */
function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Страница с одноразовым токеном из письма */}
            <Route path="/security/:token" element={<HomePage />} />
            {/* Все остальные пути - показываем пустоту */}
            <Route path="*" element={null} />
          </Routes>
        </div>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;